import React from "react";

const Preload = () => <span />;

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: Preload,
  component: Preload,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/PaymentWallet/Preload/index.js